import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useApp } from "../contexts/AppContext";

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useApp();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/profile";
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(form);
      nav(next, { replace: true });
    } catch (ex) {
      const code = ex?.code || "";
      const map = {
        "auth/invalid-credential": "Email və ya parol səhvdir.",
        "auth/invalid-email": "Email formatı düzgün deyil.",
        "auth/too-many-requests": "Çox cəhd. Bir az gözləyin.",
      };
      setErr(map[code] || ex.message || "Giriş alınmadı.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="metadata mb-3">{t.common.account}</div>
        <h1 className="section-title text-5xl">{t.common.login}</h1>
        <form onSubmit={onSubmit} className="mt-10 space-y-4">
          <input className="w-full bg-transparent border border-[var(--border)] px-4 py-3 outline-none focus:border-[var(--primary)] font-mono text-base"
                 placeholder="email" value={form.email}
                 onChange={(e) => setForm({ ...form, email: e.target.value })}
                 type="email" required data-testid="login-email" />
          <div className="relative">
            <input className="w-full bg-transparent border border-[var(--border)] pl-4 pr-12 py-3 outline-none focus:border-[var(--primary)] font-mono text-base"
                   placeholder="password" value={form.password}
                   onChange={(e) => setForm({ ...form, password: e.target.value })}
                   type={showPwd ? "text" : "password"} required data-testid="login-password" />
            <button
              type="button"
              onClick={() => setShowPwd((v) => !v)}
              aria-label={showPwd ? "Parolu gizlət" : "Parolu göstər"}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--text-2)] hover:text-[var(--text)] transition"
              data-testid="login-toggle-password"
            >
              {showPwd ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {err && <div className="text-[var(--accent)] text-sm">{err}</div>}
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {loading ? "…" : t.common.login}
          </button>
        </form>
        <div className="mt-6 metadata">
          {t.common.newHere} <Link to="/register" className="link-underline text-[var(--primary)]">{t.common.register}</Link>
        </div>
      </div>
    </div>
  );
}
